// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAeHYgVdL1RcpiuLZ-G1mEtqEtg1GWHhxM",
  authDomain: "copysa-app.firebaseapp.com",
  projectId: "copysa-app",
  storageBucket: "copysa-app.firebasestorage.app",
  messagingSenderId: "343094667086",
  appId: "1:343094667086:web:1d740dfe511aa33c46601f",
  measurementId: "G-RKGR35PRX6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { app, messaging };